"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NOT_LAMBDA = exports.NOT_CLOUD = exports.LOG_AT_LEVEL = exports.IS_LAMBDA = exports.IS_FARGATE = exports.IS_CLOUD = exports.DEBUG_OVERRIDE = void 0;
const REACT_APP_PROJECT_CODE = process.env.REACT_APP_PROJECT_CODE;
const { DEBUG_OVERRIDE: L_DEBUG_OVERRIDE, DEBUG_OVERRIDE_HOURS_LIMIT, LAST_DEPLOY_UTC, LOG_AT_LEVEL, } = process.env;
exports.LOG_AT_LEVEL = LOG_AT_LEVEL;
const IS_LAMBDA = process.env.AWS_SESSION_TOKEN !== undefined;
exports.IS_LAMBDA = IS_LAMBDA;
const NOT_LAMBDA = !IS_LAMBDA && !(REACT_APP_PROJECT_CODE && process.env.NODE_ENV === 'production');
exports.NOT_LAMBDA = NOT_LAMBDA;
const IS_FARGATE = process.env.AWS_EXECUTION_ENV === 'AWS_ECS_FARGATE';
exports.IS_FARGATE = IS_FARGATE;
const IS_CLOUD = IS_FARGATE || IS_LAMBDA;
exports.IS_CLOUD = IS_CLOUD;
const NOT_CLOUD = !IS_CLOUD;
exports.NOT_CLOUD = NOT_CLOUD;
const userDebugOverride = L_DEBUG_OVERRIDE === 'true';
const nowUTC = new Date();
const deployUTC = LAST_DEPLOY_UTC ? new Date(LAST_DEPLOY_UTC) : undefined;
const hoursLimit = DEBUG_OVERRIDE_HOURS_LIMIT ? parseInt(DEBUG_OVERRIDE_HOURS_LIMIT) : undefined;
const cutoffUTC = deployUTC ? new Date(deployUTC) : undefined;
if (cutoffUTC && hoursLimit) {
    cutoffUTC.setHours(cutoffUTC.getHours() + hoursLimit);
}
const DEBUG_OVERRIDE = userDebugOverride && deployUTC !== undefined && hoursLimit !== undefined && cutoffUTC !== undefined && cutoffUTC.valueOf() > nowUTC.valueOf();
exports.DEBUG_OVERRIDE = DEBUG_OVERRIDE;
userDebugOverride &&
    console.log('Consts in lambdaDebug', { IS_LAMBDA, NOT_LAMBDA, nowUTC, deployUTC, hoursLimit, cutoffUTC, userDebugOverride, DEBUG_OVERRIDE });
